import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Italian labels for every `mat-paginator`.
 *
 * Material ships English strings and there is no locale-driven fallback: `LOCALE_ID`
 * and `MAT_DATE_LOCALE` do nothing for the paginator, so without this provider an
 * otherwise entirely Italian console reads "Items per page: 10 — 1 – 7 of 7".
 */
@Injectable()
export class ItPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Righe per pagina:';
  override nextPageLabel = 'Pagina successiva';
  override previousPageLabel = 'Pagina precedente';
  override firstPageLabel = 'Prima pagina';
  override lastPageLabel = 'Ultima pagina';

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 di ${length}`;
    }

    const total = Math.max(length, 0);
    const start = page * pageSize;
    // The last page is rarely full, so the end index is clamped rather than computed —
    // otherwise the final page reads "61 – 70 di 67".
    const end = Math.min(start + pageSize, total);

    return `${start + 1} – ${end} di ${total}`;
  };
}
